import type { Page } from '../../types';

const minStandardLeadership: Page[] = [
  {
    pageType: 'question',
    title: 'Minimum Standards',
    name: 'minimum-standards',
    hidePageTitle: true,
    description:
      'A conversation must take place at the start of the year between you and your line manager to agree how these standards will be demonstrated in a way that is relevant to your role. You should agree how you will determine whether you have ‘met’ these <a href="https://intranet.cabinetoffice.gov.uk/documents/2180/3717_SCS_Minimum_Standards_AW_3nspT0U.pdf" target="_blank" rel="noopener noreferrer">minimum standards</a>.<br><br>Line Managers will make judgements on whether standards have been met as part of their validation.<br><br>Please complete the box below on how you have met each of the Minimum Standards. Please refer to evidence captured throughout the performance year<br><br>',
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Leadership',
        name: 'minimum-standard-leadership',
        detailsHeading: 'More information',
        detailsContent: `The minimum Leadership standards require all SCS to:<br><ul>
  <li>Budgetary responsibilities: type (e.g. admin/capital/programme), value and description (what is the budget for).</li>
  </ul>`,
        hint: `How will this be demonstrated in my role?  
  • Behaviours should be treated with equal weight as to what is delivered. It is important that members of the SCS are demonstrating and role modelling leadership behaviours expected in the Civil Service. Civil Service behaviours are set out in [Success Profiles](https://www.gov.uk/government/publications/success-profiles/success-profiles-civil-service-behaviours) and should be used in conjunction with [CO Leadership Commitments](https://intranet.cabinetoffice.gov.uk/about-the-cabinet-office/governance-and-leadership/new-leadership-commitments/).`,
        wordCount: 250,
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default minStandardLeadership;
